import { Inject, Injectable } from "@angular/core";
import { CommonService } from "../core/services/common.service";
import { environment } from "../../environments/environment";
import { apiConfig } from "../api-url.config";
import { catchError, finalize, map } from "rxjs/operators";
import { throwError } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import {
  LOCAL_STORAGE,
  SESSION_STORAGE,
  StorageService,
} from "ngx-webstorage-service";
import { AlertService } from "ngx-alerts";

@Injectable({
  providedIn: "root",
})
export class DashboardService extends CommonService {
  API_END_POINT: string;

  branches: any[] = [];
  channelId = "";
  myBranch = {
    branchName: "My Branch",
    userName: "",
    channelId: "",
  };

  selectedBranch: any = {
    branchName: "",
    userName: "",
    channelId: "",
  };
  API_RAZOR_PAY_IFSC: string;
  loggedInUserDetails: any;

  constructor(
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private alertService: AlertService
  ) {
    super();
    this.loggedInUserDetails = storage.get("gs-loggedInUser");
    this.channelId = this.loggedInUserDetails.channelId;
    this.myBranch.channelId = this.loggedInUserDetails.channelId;
    this.API_END_POINT = environment.API_SERVER;
    this.API_RAZOR_PAY_IFSC = environment.API_RAZOR_PAY_IFSC;
    this.getBranches(this.myBranch);
  }

  getDashboardData(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.dashboard.dashboardData}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  getCustomers(customerSearch: any) {
    let params = this.generateHttpParams(customerSearch);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.customers.getCustomers}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  getGameLevelConfigs(userId: any) {
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.garage.fleet}/${userId}${apiConfig.garage.gameLevelConfigs}`
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  updateGameLevelConfigs(userId: any, payload) {
    return this.httpClient
      .put(
        `${this.API_END_POINT}${apiConfig.garage.fleet}/${userId}${apiConfig.garage.gameLevelConfigsUpdate}`,
        payload
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  addCustomer(value: any) {
    return this.httpClient
      .post(`${this.API_END_POINT}${apiConfig.customers.addCustomer}`, value)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  addFuelExpense(vehicelId: string, payload: any) {
    console.log(apiConfig.vehicles)
    console.log(`${apiConfig.vehicles.vehicle}/${vehicelId}/${apiConfig.vehicles.fuelExpenseAdd}`)
    return this.httpClient
      .post(`${this.API_END_POINT}${apiConfig.vehicles.vehicle}/${vehicelId}/${apiConfig.vehicles.fuelExpenseAdd}`, payload)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getUserVehicles(customerId: any) {
    return this.httpClient
      .post(
        `${this.API_END_POINT}${apiConfig.user}/${customerId}${apiConfig.vehicles.vehicles}`,
        {}
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getFuelExpenses(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.vehicles.fuelExpenses}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getFuelExpenseMetrics(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.vehicles.fuelExpenseMetrics}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getUserTrips(customerId: any, search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.vehicles.userTrips}/${customerId}`,
        { params }
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getUserTripsByVehicle(
    vehicleId: any,
    search: { size: number; page: number }
  ) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.vehicles.vehicle}/${vehicleId}${apiConfig.vehicles.trips}`,
        { params }
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getDrivingAlerts(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.vehicles.drivingAlerts}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getVehicleAlerts(vehicleId: any, search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.vehicles.vehicle}/${vehicleId}${apiConfig.vehicles.alerts}`,
        { params }
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getAlertCustomers(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.vehicles.alertCustomers}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getRemindersUsers(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.vehicles.reminderCustomers}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  public getTeamMates(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.team.getTeamUsers}`, { params })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  addTeamMember(value: any) {
    return this.httpClient
      .post(`${this.API_END_POINT}${apiConfig.team.addTeamMate}`, value)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  public getRoles() {
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.team.getRoles}`)
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  public getBranches(search: any) {
    this.spinner.show();
    this.getTeamMates(search)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.branches = res.teamMembers;
        },
        (error1) => {
          console.error(error1);
          this.alertService.danger(error1.message ? error1.message : error1);
        }
      );
  }

  uploadToCloudinary(payload: any) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    return this.httpClient
      .post(
        `https://api.cloudinary.com/v1_1/` +
          environment.cloudinary.cloudName +
          `/auto/upload`,
        payload,
        { headers }
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err.error);
        })
      );
  }

  fetchBankDetailsByIFSCCode(ifscCode: string[]) {
    return this.httpClient.get(`${this.API_RAZOR_PAY_IFSC}/${ifscCode}`).pipe(
      map((res: any) => res),
      catchError((err: any) => {
        return throwError(err.error);
      })
    );
  }

  getTripDetailsById(tripId: string, tripParams: any) {
    let params = this.generateHttpParams(tripParams);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.trip.trip}/${tripId}`, { params })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getTripLatlongs(tripId: string) {
    return this.httpClient
      .post(
        `${this.API_END_POINT}${apiConfig.trip.trip}/${tripId}/${"latlongs"}`,
        {}
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getTripDrivingAlerts(tripId: string) {
    return this.httpClient
      .get(
        `${this.API_END_POINT}${
          apiConfig.trip.trip
        }/${tripId}/${"driving/alerts"}`,
        {}
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getTripVehicleAlerts(tripId: string) {
    return this.httpClient
      .get(
        `${this.API_END_POINT}${
          apiConfig.trip.trip
        }/${tripId}/${"vehicle/alerts"}`,
        {}
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getOS() {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  }

  onRaiseTickerClick() {
    let userType = this.storage.get("gs-loggedInUserType");
    let platform = this.getOS();
    if (platform == "Android" || platform == "Mac OS" || platform == "iOS") {
      let link =
        "mailto:hello@getfuelshine.com?subject=Technical Assistance Request&body=" +
        (this.loggedInUserDetails?.userName || "") +
        "%0d%0a " +
        (this.loggedInUserDetails?.userPhoneNumber || "") +
        "%0d%0a" +
        userType +
        "%0d%0a %0d%0a ";
      let win = window.open(link, "_blank");
      win.focus();
      setTimeout(() => win?.close(), 2000);
    } else {
      let link =
        "https://mail.google.com/mail/u/" +
        this.loggedInUserDetails.userEmail +
        "/?view=cm&fs=1&to=hello@getfuelshine.com&su=Technical Assistance Request&body=" +
        (this.loggedInUserDetails?.userName || "") +
        "%0d%0a " +
        (this.loggedInUserDetails?.userPhoneNumber || "") +
        "%0d%0a" +
        userType +
        "%0d%0a %0d%0a ";
      console.log(link);
      let win = window.open(link, "_blank");
      win.focus();
    }
  }

  getLocationDetails(lat: any, lng: any) {
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.trip.locationDetails}/${lat}/${lng}`,
        {}
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getAllDriversVehicles(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.vehicles.customerVehicles}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getUserMobileDeviceStatus(userId: any) {
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.mobileDeviceStatus}`
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getUserDrivingAnalytics(userId: string) {
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.drivingAnalytics}`,
        {}
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getDrivingAlertOfVehicle(search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(`${this.API_END_POINT}${apiConfig.vehicles.drivingAlerts}`, {
        params,
      })
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  updateVehicle(userVehicleId: any, payload: any) {
    return this.httpClient
      .put(
        `${this.API_END_POINT}${apiConfig.vehicles.vehicle}/${userVehicleId}${apiConfig.vehicles.update}`,
        payload
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getDriverRiskAnalysis(userId: any, search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.riskAnalysis}`,
        { params }
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  getDrivingAlertsAnalysis(userId: any, search: any) {
    let params = this.generateHttpParams(search);
    return this.httpClient
      .get(
        `${this.API_END_POINT}${apiConfig.user}/${userId}${apiConfig.drivingAlertsAnalysis}`,
        { params }
      )
      .pipe(
        map((res: any) => res),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
}
